import { choiceEligible, type ChoiceContext, type ChoiceView } from '../model/choices';

/** A peer's sealed submission can remove owners without changing this seat's
 * decision. Preserve its local answers only for that strictly narrowing window
 * and an identical descriptor. A new window/turn or changed domain resets it. */
export function retainsPeerDecisionDraft(previous: ChoiceContext, current: ChoiceContext, choice: ChoiceView, choices: ChoiceView[]): boolean {
  if (choice.scope === 'auxiliary' || previous.selfSeat !== current.selfSeat || !choiceEligible(previous, choice) || !choiceEligible(current, choice)) return false;
  const before = previous.decisionOwners;
  const after = current.decisionOwners;
  if (!before || !after || before.length < 2 || after.length >= before.length || !after.every(owner => before.includes(owner))) return false;
  const replacement = choices.find(candidate => candidate.id === choice.id);
  return !!replacement && JSON.stringify(replacement) === JSON.stringify(choice);
}
